// extracted by mini-css-extract-plugin
export default {"grid":"Audience_grid__3gZAg","card":"Audience_card__25xSu"};